"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    MEDIA_QUERY_BREAKPOINT_SELECTOR: function() {
        return MEDIA_QUERY_BREAKPOINT_SELECTOR;
    },
    SURFACE_PADDING: function() {
        return SURFACE_PADDING;
    },
    DIALOG_GAP: function() {
        return DIALOG_GAP;
    },
    SURFACE_BORDER_WIDTH: function() {
        return SURFACE_BORDER_WIDTH;
    }
});
const MEDIA_QUERY_BREAKPOINT_SELECTOR = '@media screen and (max-width: 480px)';
const SURFACE_PADDING = '24px';
const DIALOG_GAP = '8px';
const SURFACE_BORDER_WIDTH = '1px';
